export const getBoxShadow = (spreadRadius, color) => `inset 0 0 0 ${spreadRadius}rem ${color}`;